import axios from '../../utils/axios.js'

export const query = (query) => axios.setAxiosGetPromise('account', query)

export const getUser = (id) => axios.setAxiosGetPromise('account/' + id)

export const add = (options) => axios.setAxiosPostPromise('account', options)

export const update = (query, options) => axios.setAxiosPutPromise('account/' + query, options)

export const deleteUser = (query) => axios.setAxiosDeletePromise('account/' + query)

export const login = (options) => axios.setAxiosPostPromise('account/login', options)
export const loginByJaccount = (options) => axios.setAxiosPostPromise('account/loginByJaccount', options)

export const tokenVerify = (options) => axios.setAxiosPostPromise('account/tokenVerify', options)

export const logout = () => axios.setAxiosGetPromise('account/logout')

export const forgetPasswd = () => axios.setAxiosGetPromise('account/forgetPasswd')

export const userListByUserName = (query) => axios.setAxiosGetPromise('account/userName', query)

export const userAll = (query) => axios.setAxiosGetPromise('account/userAll', query)

// export const getNewToken = (query) => axios.setAxiosGetPromise('/cas/id_refresh_token', query)

export const updateIdtoken = (query) => axios.setAxiosPutPromise('/cas/updateIdtoken', query)

export const userToken = (query) => axios.setAxiosGetPromise('/cas/id_token', query)

// 调用交大接口
// 获取交大access_token
export const getTokenSJ = (query) => axios.setAxiosPostPromise('/sj/getToken', query)
export const getUserInfoSJ = (query) => axios.setAxiosGetPromise('/sj/getUserInfo', query)
export const logoutByJaccount = (query) => axios.setAxiosGetPromise('/sj/logout', query)
export const getCsInfos = (query) => axios.setAxiosGetPromise('/sj/getCsInfos', query)




// WEBPACK FOOTER //
// ./src/services/system/user.js